import type { SearchResultType} from '@zoomit/web-kit';
import { ApiManager, searchV2 } from '@zoomit/web-kit';

export const searchApi = async ({
  query,
  articlesPageSize,
  articlesPageNumber,
  groupingsPageSize,
  groupingsPageNumber,
  authorsPageSize,
  authorsPageNumber,
}: {
  query: string;
  articlesPageNumber?: number;
  articlesPageSize?: number;
  groupingsPageNumber?: number;
  groupingsPageSize?: number;
  authorsPageNumber?: number;
  authorsPageSize?: number;
}) => {
  const searchUrl = new URL(searchV2);
  const params = new URLSearchParams({
    Query: query,
  });

  if (articlesPageNumber) {
    params.append('Articles.PageNumber', `${articlesPageNumber}`);
  }

  if (articlesPageSize) {
    params.append('Articles.PageSize', `${articlesPageSize}`);
  }

  if (groupingsPageNumber) {
    params.append('Groupings.PageNumber', `${groupingsPageNumber}`);
  }

  if (groupingsPageSize) {
    params.append('Groupings.PageSize', `${groupingsPageSize}`);
  }

  if (authorsPageNumber) {
    params.append('Authors.PageNumber', `${authorsPageNumber}`);
  }

  if (authorsPageSize) {
    params.append('Authors.PageSize', `${authorsPageSize}`);
  }

  searchUrl.search = params.toString();
  return await ApiManager.get<SearchResultType>(searchUrl.toString());
};
